import currentUserSlice from "./slices/current-user";

export const {
    selectCurrentAccount,
    selectCanAccessInstall,
    selectCanAccessApplications,
    selectCanAccessLiveProctoring,
    selectCanAccessFeedback,
    selectCanAccessEventBanners
} = currentUserSlice.selectors;

export { selectCanEditInstitution } from "./slices/current-user";
